<h3 *ngIf="section.name" class="section-header">
  <mat-icon *ngIf="section.iconName">{{section.iconName}}</mat-icon>
  {{section.name}}<i *ngIf="section.isOptional"> (Optional)</i>
</h3>

<p *ngIf="section.optionalDescription">{{section.optionalDescription}}</p>

<ng-content></ng-content>
